/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * One message a send sent, as Communication keeps it: an email, with its
 * subject, or a text. A card's (its preview): one it would send now, with
 * no id yet.
 */
export type ActivitySentMessage = {
  message_id?: number | null;
  channel: ActivitySentMessage.channel;
  subject?: string | null;
  body: string;
};

export namespace ActivitySentMessage {
  export enum channel {
    EMAIL = "email",
    SMS = "sms",
  }
}
